import {
  PageInformationContent,
  PageInformationList,
  PageInformationDivider,
  IPageInformationListProps,
} from '@reapitform/dashboard-ui'
import React from 'react'

const SidebarInformation: React.FC<Omit<IPageInformationListProps, 'tag' | 'children'>> = (props) => {
  return (
    <PageInformationList tag="section" {...props}>
      <PageInformationContent
        iconName="glasses-invisible"
        title="What others can see"
        description="Your business and contact details are applied to all documents by default and visible to everyone."
      />
      <PageInformationDivider />
      <PageInformationContent
        iconName="pencil-edit-square"
        title="Customising the experience"
        description="Agreement links will display your agency logo and contact information. All communications will have your agency details in the signature field."
      />
    </PageInformationList>
  )
}

export default SidebarInformation
